// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_bv-0";
export var orangeButton = "_bv-1";